import { NavLink } from "react-router-dom";
import { menuItems } from "../menu";
import "./ConsoleSidebar.scss";

/**
 * 左侧菜单：菜单项用 NavLink 渲染，选中态由 react-router 自动加的 .active 类控制。
 */
const ConsoleSidebar = () => {
  return (
    <aside className="cs-sidebar">
      <nav className="cs-sidebar__nav">
        {menuItems.map((item) => (
          <NavLink key={item.path} to={item.path} className="cs-sidebar__link">
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default ConsoleSidebar;
